import { useReducer } from 'react'
import { createContainer } from 'react-tracked'

import { State } from './store.types'
import storeReducer from './storeReducer'

const initialState: State = {}

const useValue = () => useReducer(storeReducer, initialState)

export const {
  Provider: StoreProvider,
  useTrackedState: useStore,
  useUpdate: useDispatch,
} = createContainer(useValue)
